'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './collection-edit.routes';

export class CollectionEditComponent {

  constructor(Auth, dialogs, SettingsService, $uibModal, $state, $stateParams, $location, Config, StorageService) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.Auth = Auth;
    this.$location = $location;
    this.SettingsService = SettingsService;
    this.StorageService = StorageService;

    this.type = $stateParams.name;

    this.setting = {};
    this.dataSetting = {};

    SettingsService.getByName({name: this.type + '-collection-config'}, configSettings => {
      this.setting = configSettings.data;

      SettingsService.getByName({name: this.type + '-collection-data'}, dataSetting => {
        this.dataSetting = dataSetting;
      }, err => {
      });
    }, err => {
    });

    this.sortableOptions = {
        handle: '.handle'
    };
  }

  addItem() {
    this.dataSetting.data.push({});
  }

  deleteItem($event, item, idx) {
    $event.stopPropagation();

    var dlg = this.dialogs.confirm("Delete Entry?", "Do you really want to delete the entry '" + (item[this.setting.primaryField]) + "'?");
    dlg.result.then(() => {
      this.dataSetting.data.splice(idx,1);
    }, () => {
      // Cancel
    });

  }

  create(form) {
    var onSuccess = (data) => {
      this.dialogs.notify("Success", "Changes have been saved successfully");
    };

    var onError = err => {
      this.dialogs.error("Error","There has been an error trying to save the settings");
    };

    this.SettingsService.update({id: this.dataSetting._id}, this.dataSetting, onSuccess, onError);
  }

}

export default angular.module('conduuApp.collectionEdit', [uiRouter])
  .config(routes)
  .component('collectionEdit', {
    template: require('./collection-edit.html'),
    controller: CollectionEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/collection/edit/collection-edit.component.js